module.exports = __webpack_public_path__ + "static/media/vip4.8ac4a2db.png";